<template>
  <div class="Others29Charts">
    <!-- 左侧区域 -->
    <div class="left-panel">
      <!-- padding: `${$w_Ratio(-30 + getShowfontSizeBase(), $store)}px  0`, -->
      <div
        class="panel-title"
        :style="{
          width: '100%',
          height: 5 + '%',
          fontSize: FontSize.titleSize + 'px',
          color: FontSize.titleColor,
        }"
      >
        总蹲位数据
      </div>
      <div class="panel-content">
        <div class="toilet-stats">
          <div class="top">
            <div class="icon toilet-icon">
              <img src="@/assets/img/toilet/Vector.png" alt="" />
            </div>
            <div class="text">
              <div class="totlo">
                <span :style="getWidthStyle()">总蹲位</span>
                <span :style="getWidthStyle()">{{ toilet.total ? toilet.total : 17 }}个</span>
              </div>
              <div class="status">
                <span :style="getWidthStyle()" class="used">使用中 {{ toilet.use ? toilet.use : 0 }}</span>
                <span :style="getWidthStyle()" class="free">空余 {{ toilet.free ? toilet.free : 17 }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="gender-toilet">
          <!-- <div class="toilet-info"> -->
          <div class="item">
            <div class="icon gender-icon">
              <img src="@/assets/img/toilet/nan.png" alt="" />
            </div>
            <div class="item-content">
              <div class="item-text">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[0].s ? toilet.toiletlist[0].s : '厕所' }} (占用/总数)</span
                >
              </div>
              <div class="item-num">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[0].y ? toilet.toiletlist[0].y : 0 }}
                </span>
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[0].x ? toilet.toiletlist[0].x : 6 }}
                </span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="icon gender-icon">
              <img src="@/assets/img/toilet/nv.png" alt="" />
            </div>
            <div class="item-content">
              <div class="item-text">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[1].s ? toilet.toiletlist[1].s : '厕所' }} (占用/总数)</span
                >
              </div>
              <div class="item-num">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[1].y ? toilet.toiletlist[1].y : 0 }}
                </span>
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[1].x ? toilet.toiletlist[1].x : 9 }}
                </span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="icon gender-icon">
              <img src="@/assets/img/toilet/san.png" alt="" />
            </div>
            <div class="item-content">
              <div class="item-text">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[2].s ? toilet.toiletlist[2].s : '厕所' }} (占用/总数)</span
                >
              </div>
              <div class="item-num">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[2].y ? toilet.toiletlist[2].y : 0 }}
                </span>
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[2].x ? toilet.toiletlist[2].x : 1 }}
                </span>
              </div>
            </div>
          </div>
          <div class="item">
            <div class="icon gender-icon">
              <img src="@/assets/img/toilet/san.png" alt="" />
            </div>
            <div class="item-content">
              <div class="item-text">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[3].s ? toilet.toiletlist[3].s : '厕所' }} (占用/总数)</span
                >
              </div>
              <div class="item-num">
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[3].y ? toilet.toiletlist[3].y : 0 }}
                </span>
                <span :style="getWidthStyle(-22, 2)"
                  >{{ toilet.toiletlist[3].x ? toilet.toiletlist[3].x : 1 }}
                </span>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>

    <!-- 中间地图区域 -->
    <div class="middle-panel">
      <div
        class="map-title"
        :style="{
          height: 5 + '%',
          fontSize: FontSize.titleSize + 'px',
          color: FontSize.titleColor,
        }"
      >
        {{ Configuration.propertyData.titleText.value }}
        <!-- 龙井沟风景区 -->
      </div>
      <div class="map-container">
        <div class="GisMapBackground" id="container"></div>
      </div>
    </div>

    <!-- 右侧环境数据区域 -->
    <div class="right-panel">
      <div
        class="panel-title"
        :style="{
          width: '100%',
          height: 5 + '%',
          fontSize: FontSize.titleSize + 'px',
          color: FontSize.titleColor,
        }"
      >
        环境数据
      </div>
      <div class="panel-content">
        <div class="toilet-stats">
          <div class="top">
            <div class="icon toilet-icon">
              <img src="@/assets/img/toilet/hjsj.png" alt="" />
            </div>
            <div class="text">
              <div class="totlo">
                <span :style="getWidthStyle()">环境数据</span>
              </div>
            </div>
          </div>
        </div>
        <div class="env-data">
          <div class="item">
            <div class="icon">
              <img
                :style="{
                  width: $h_Ratio(50, $store) + 'px',
                }"
                src="@/assets/img/toilet/wd.png"
                alt=""
              />
              <div class="info" :style="getWidthStyle(-22, 1.4)">
                <span> {{ toilet.temperature ? toilet.temperature : 23.3 }}℃</span>
                <span>温度</span>
              </div>
            </div>
            <div
              :style="{
                fontWeight: 'bold',
                fontSize: FontSize.yAxisSize + 'px',
              }"
            >
              {{ getTemperatureStatus(toilet.temperature) }}
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img
                :style="{
                  width: $h_Ratio(50, $store) + 'px',
                }"
                src="@/assets/img/toilet/sd.png"
                alt=""
              />
              <div class="info" :style="getWidthStyle(-22, 1.4)">
                <span>{{ toilet.humidity ? toilet.humidity : 60.3 }}%</span>
                <span>湿度</span>
              </div>
            </div>
            <div
              :style="{
                fontWeight: 'bold',
                fontSize: FontSize.yAxisSize + 'px',
              }"
            >
              {{ getHumidityStatus(toilet.humidity) }}
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img
                :style="{
                  width: $h_Ratio(50, $store) + 'px',
                }"
                src="@/assets/img/toilet/lhq.png"
                alt=""
              />
              <div class="info" :style="getWidthStyle(-22, 1.4)">
                <span> {{ toilet.sulfuretted ? toilet.sulfuretted : 0.38 }}mg/m</span>
                <span>硫化氢</span>
              </div>
            </div>
            <div
              :style="{
                fontWeight: 'bold',
                fontSize: FontSize.yAxisSize + 'px',
              }"
            >
              {{ getH2SStatus(toilet.sulfuretted) }}
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img
                :style="{
                  width: $h_Ratio(50, $store) + 'px',
                }"
                src="@/assets/img/toilet/yq.png"
                alt=""
              />
              <div class="info" :style="getWidthStyle(-22, 1.6)">
                <span> {{ toilet.ammonia ? toilet.ammonia : 0.38 }}mg/m</span>
                <span>氮气</span>
              </div>
            </div>
            <div
              :style="{
                fontWeight: 'bold',
                fontSize: FontSize.yAxisSize + 'px',
              }"
            >
              {{ getNitrogenStatus(toilet.ammonia) }}
            </div>
          </div>
          <div class="item">
            <div class="icon">
              <img
                :style="{
                  width: $h_Ratio(50, $store) + 'px',
                }"
                src="@/assets/img/toilet/fs.png"
                alt=""
              />
              <div class="info" :style="getWidthStyle(-22, 1.6)">
                <span>{{ toilet.pm25 ? toilet.pm25 : 15 }}ug/m</span>
                <span>PM2.5</span>
              </div>
            </div>
            <div
              :style="{
                fontWeight: 'bold',
                fontSize: FontSize.yAxisSize + 'px',
              }"
            >
              {{ getPM25Status(pm) }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { request } from '../../../common/request';
import Icon from '../../../assets/icon/location1.png';
export default {
  name: 'Others29Charts',
  props: {
    ProjectInfo: Object,
    Configuration: Object,
    ComboBoxCharts: Object,
  },
  watch: {
    Configuration: {
      deep: true,
      handler: function (nV) {
        if (nV.propertyData.gisMapConfig.value) {
          this.pointVideoPoint(nV.propertyData.gisMapConfig.value);
        }
      },
    },
  },
  computed: {
    FontSize() {
      return this.Configuration.propertyData.fontStyle.value;
    },
  },
  data() {
    return {
      debounce_subscribeConfigurationChange: null, // 订阅Configuration变化的防抖函数
      apiIntervalTaskID: null, // api任务的定时器ID
      staticIntervalTaskID: null, // 静态任务的定时器ID
      noData: false, // 是否没有数据
      fontStyle: {},
      dataSet: {
        seriesList: [],
        source: [],
      },
      mywpoint: null,
      mapType: 2, // 地图类型
      mapBasicSetting: null,
      params: {}, // 请求参数
      paramsCopy: {},
      toilet: {
        total: 0,
        use: 0,
        free: 0,
        temperature: 0,
        humidity: 0,
        ammonia: 0,
        sulfuretted: 0,
        toiletlist: [
          { t: 'WOMAN', s: '男卫', y: 0, x: 0 },
          { t: 'WOMAN', s: '女卫', y: 0, x: 0 },
          { t: 'WOMAN', s: '第三卫', y: 0, x: 0 },
          { t: 'WOMAN', s: '母婴室', y: 0, x: 0 },
        ],
      },
      mapKey: 'WKvseQPCaNwRbBDnLJtnm',
      gisConfig: '',
    };
  },
  created() {},
  mounted() {
    clearInterval(this.apiIntervalTaskID);
    clearInterval(this.staticIntervalTaskID);
    clearInterval(this.staticIntervalTaskID2);
    this.registerDebounceAndThrottle();
    this.$nextTick(() => {
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
      this.initMap();
    });

    let that = this;
    let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
    let params = ChartsData?.apiData?.apiPostParams || '{}';
    this.params = eval('(' + params + ')');
    this.paramsCopy = eval('(' + params + ')');
    this.mapBasicSetting = this.Configuration.propertyData.mapBasicSetting.value;
    this.mapKey = this.Configuration.propertyData.MapKey.value;

    if (this.Configuration.propertyData.gisMapConfig.value != '') {
      this.pointVideoPoint(this.Configuration.propertyData.gisMapConfig.value);
    }
  },
  methods: {
    // 温度状态判断
    getTemperatureStatus(tem) {
      if (tem === null || tem === undefined) return '舒适';
      if (tem > 0 && tem < 10) return '寒冷';
      if (tem < 18) return '偏冷';
      if (tem < 25) return '舒适';
      if (tem < 30) return '偏热';
      return '舒适';
    },
    getHumidityStatus(hum) {
      if (hum === null || hum === undefined) return '舒适';
      if (hum < 30) {
        return '干燥';
      } else if (hum < 60) {
        return '舒适';
      } else {
        return '潮湿';
      }
    },
    getNitrogenStatus(n2) {
      if (n2 === null || n2 === undefined) return '安全';
      if (n2 < 750000) {
        return '偏低';
      } else if (n2 < 800000) {
        return '正常';
      } else if (n2 < 850000) {
        return '偏高';
      } else {
        return '过高';
      }
    },
    getH2SStatus(h2s) {
      if (h2s === null || h2s === undefined) return '安全';
      if (h2s < 0.1) {
        return '安全';
      } else if (h2s < 5) {
        return '极低';
      } else if (h2s < 10) {
        return '低';
      } else if (h2s < 20) {
        return '中等';
      } else if (h2s < 50) {
        return '高';
      } else {
        return '危险';
      }
    },
    getPM25Status(pm) {
      if (pm === null || pm === undefined) return '良好';
      if (pm < 35) {
        return '优';
      } else if (pm < 75) {
        return '良';
      } else if (pm < 115) {
        return '轻度污染';
      } else if (pm < 150) {
        return '中度污染';
      } else {
        return '重度污染';
      }
    },
    getWidthStyle(fs = 14, lh = 1) {
      return {
        fontSize: ` ${this.FontSize.xAxisSize}px`,
        lineHeight: lh + 'em',
      };
    },
    getShowfontSizeBase() {
      return Math.round(this.Configuration.style.height / 20);
    },
    registerDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange = this.$_.debounce(this.subscribeConfigurationChange, 500);
    },
    unRegisterDebounceAndThrottle() {
      this.debounce_subscribeConfigurationChange.cancel();
    },
    initMap() {
      this.mywpoint = null;
      let map = document.getElementById('GisMapBackground');
      this.mywpoint = new winMap('container', {
        style: 4, // 地图风格
        maptype: 2,
        key: this.mapKey,
        maplon: this.mapBasicSetting.coordinate.lng,
        maplat: this.mapBasicSetting.coordinate.lat,
        level: this.mapBasicSetting.zoom + '',
        http_server: 'https://gisapi.xyabcd.com',
        jwt: localStorage.getItem('_t'),
      });
    },
    pointVideoPoint(val) {
      console.log(val, 'pointVideoPoint');

      if (val) {
        request({
          method: 'get',
          url: val,
          params: {},
        })
          .then(res => {
            let list = res.data.list.map(item => {
              // item.push('icon':Icon)
              return {
                ...item, // 展开原对象的所有属性
                icon: Icon, // 添加 icon 属性（值可自定义）
                title: item.name,
              };
            });

            setTimeout(() => {
              this.mywpoint.markerlist(list, {
                iconConfig: '60,60,30,40',
                iconPath: '/guangbod.svg',
                isiconPath: '',
                groupName: 'point',
                infowindowStartIndex: 0,
                infowindowType: '7',
                infowindowHeight: '130px',
                infowindowWidth: '340px',
              });
            }, 1000);
          })
          .catch(error => {
            console.error('Request failed:');
          });
      }
    },
    setEchartsOptions(ParamData = null) {
      this.fontStyle = {};
      let source = [];
      let seriesList = [];
      let total = 0;
      let use = 0;
      let free = 0;
      let ammonia = 0;
      let sulfuretted = 0;
      let temperature = 0;
      let humidity = 0;
      let fontStyle = {
        titleColor: '#ccc',
        titleSize: 16,
        xAxisColor: '#c3dbff',
        xAxisSize: 12,
        yAxisColor: '#c3dbff',
        yAxisSize: 12,
      };

      if (ParamData && ParamData.source && ParamData.seriesList) {
        source = ParamData.source;
        seriesList = ParamData.seriesList;
        total = ParamData.total;
        use = ParamData.use;
        ammonia = ParamData.ammonia;
        sulfuretted = ParamData.sulfuretted;
        temperature = ParamData.temperature;
        humidity = ParamData.humidity;
      }
      if (this.Configuration.propertyData.fontStyle.value) {
        this.fontStyle = this.Configuration.propertyData.fontStyle.value;
      }
      if (this.Configuration.propertyData?.gisMapConfig?.value) {
        this.gisConfig = this.Configuration.propertyData.gisMapConfig.value;
      }

      this.toilet.total = total;
      this.toilet.use = use;
      this.toilet.ammonia = ammonia;
      this.toilet.sulfuretted = sulfuretted;
      this.toilet.temperature = temperature;
      this.toilet.humidity = humidity;
      this.toilet.free = total - use;
      this.toilet.toiletlist = source;
    },
    // 订阅Configuration变化将会执行的函数
    subscribeConfigurationChange() {
      clearTimeout(this.apiIntervalTaskID);
      clearTimeout(this.staticIntervalTaskID);
      clearInterval(this.staticIntervalTaskID2);
      this.startApiIntervalTask();
      this.startStaticIntervalTask();
    },
    // 开启api动态任务 数据是动态的
    async startApiIntervalTask() {
      // 清除之前的 interval 任务（如果有的话）
      if (this.apiIntervalTaskID) {
        clearInterval(this.apiIntervalTaskID);
      }
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      // 判断是否使用apiData，使用动态interval请求
      if (ChartsData?.currenEntry === 'apiData' && ChartsData?.apiData?.isUseInterval) {
        // 定义一个异步函数来处理数据请求和更新
        const fetchAndUpdateData = async () => {
          let res = await this.getApiDataResByFilterAndResponseQuery();
          this.setEchartsOptions(res);
        };
        // 首次调用
        fetchAndUpdateData();
        // 设置 interval 定时任务
        this.apiIntervalTaskID = setInterval(fetchAndUpdateData, ChartsData?.apiData?.apiInterval * 1000);
        console.log('开启 interval 任务，间隔请求');
      } else if (ChartsData?.currenEntry === 'apiData') {
        // console.log('不开启interval任务 只处理一次请求');
        let res = await this.getApiDataResByFilterAndResponseQuery();
        this.setEchartsOptions(res);
      }
    },
    // 开启静态任务 数据是静态的
    startStaticIntervalTask() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let chartsAnimation = this.Configuration?.propertyData?.chartsAnimation?.value;
      if (ChartsData?.currenEntry === 'staticData' && chartsAnimation?.isUseStaticRefresh) {
        // console.log('使用静态任务');
        let func = () => {
          let data = this.$_.cloneDeep(ChartsData.staticData);

          data.source.forEach(item => {
            item.y = 1;
          });

          this.setEchartsOptions(data);
          setTimeout(() => {
            this.setEchartsOptions(this.$_.cloneDeep(ChartsData.staticData));
          }, 0);
        };
        clearInterval(this.staticIntervalTaskID);
        func();

        this.staticIntervalTaskID = setTimeout(() => {
          console.log('任务执行staticData');
          console.log(chartsAnimation);
          func();
        }, chartsAnimation?.staticRefreshIntervalTime * 1000);

        this.staticIntervalTaskID2 = setTimeout(() => {
          func();
        }, (chartsAnimation?.staticRefreshIntervalTime - 2 <= 0 ? 1 : chartsAnimation?.staticRefreshIntervalTime - 2) * 1000);
      } else if (ChartsData?.currenEntry === 'staticData') {
        console.log('无静态任务 执行staticData');
        this.setEchartsOptions(ChartsData.staticData);
      }
    },
    // promise 返回api链接的请求数据 使用ResponseQuery和过滤器函数
    getApiDataResByFilterAndResponseQuery() {
      return new Promise((resolve, reject) => {
        let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
        if (!ChartsData) reject('Error ChartsData 不存在！');
        let filter = function (data, filter_text) {
          let dataSet = {};
          eval(filter_text);
          return dataSet;
        };
        this.getApiDataRes()
          .then(res => {
            // query数据
            let arryQuery = ChartsData.apiData.apiResponseQuery.split('.');
            if (arryQuery.length >= 1) {
              arryQuery.forEach(item => {
                res = res[item];
              });
            }
            // 判断是否使用过滤器
            if (ChartsData.apiData.isUseFilter) {
              res = filter(res, ChartsData.apiData.apiFilter);
            }
            // console.log('getApiDataResByFilterAndResponseQuery');
            let data = this.$_.cloneDeep(res);
            resolve(data);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getApiDataRes() {
      let ChartsData = this.Configuration?.propertyData?.ChartsData?.value;
      let that = this;
      return new Promise((resolve, reject) => {
        if (!ChartsData) resolve('Error ChartsData 不存在！');
        if (!ChartsData.apiData?.apiUrl) resolve('Error apiUrl 不存在！');
        let header;
        if (ChartsData.apiData?.isUseUserKey) {
          let user_key = localStorage.getItem('user_key');

          if (user_key == 'undefined' || user_key == 'null' || user_key == null) user_key = this.$userKey;
          header = {
            userkey: user_key,
          };
        } else {
          header = {};
        }
        if (ChartsData.apiData?.apiUrlMethod == 'get') {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };
          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        } else {
          let param = {
            method: ChartsData.apiData.apiUrlMethod,
            url: ChartsData.apiData.apiUrl,
            params: this.params,
            headers: header,
          };

          request(param)
            .then(res => {
              let data = this.$_.cloneDeep(res);
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
  },
  beforeUnmount() {
    clearTimeout(this.apiIntervalTaskID);
    clearTimeout(this.staticIntervalTaskID);
    this.unRegisterDebounceAndThrottle();
  },
  Configuration: {
    componentTitle: '智慧厕所3.0',
    componentName: 'Others29Charts',
    componentOverViewImg: './img/charts/OthersCharts/Others29Charts.png',
    id: '',
    style: {
      width: 1253,
      height: 579,
      left: 0,
      top: 0,
    },
    isScaling: false,
    isMoving: false,
    propertyData: {
      titleText: {
        value: '图表标题',
        lable: '图表标题',
        propertyComponentName: 'SingleInputor',
      },

      borderConfig: {
        propertyComponentName: 'ChartsBorderConfiger',
        value: {
          borderComponentName: 'Charts1Border',
        },
      },
      chartsColor: {
        propertyComponentName: 'ArrayColorSelector',
        value: {
          chartColor: [
            'rgba(223,65,56,1)',
            'rgba(229,115,63,1)',
            'rgba(240,189,108,1)',
            'rgba(237,214,102,1)',
            'rgba(77,168,222,1)',
            'rgba(25,168,164,1)',
          ],
          chartBackgroundColor: 'rgba(34, 46, 57, 0.04)',
        },
      },
      ChartsData: {
        lable: '数据接入',
        propertyComponentName: 'ChartsDataConfigor',
        value: {
          currenEntry: 'staticData',
          apiData: {
            apiUrl:
              'https://restapi.amap.com/v3/weather/weatherInfo?city=%E6%9D%AD%E5%B7%9E&output=json&key=db5d2728c584e5884c385c2a509b29b9&extensions=all',
            // apiUrl:
            // 'http://192.168.0.173/gthmmc_v4.0/gthmmc/index.php?m=sdms&c=dataMange&a=completeStatisticsdata&data=%7B%22type%22:%22%E6%80%BB%E6%95%B0%22,%22date_start%22:%22202one-0three-01%22,%22date_end%22:%22202one-0three-31%22%7D&directory_code=pro_ownerstatistics&type=day',
            apiResponseQuery: 'data.forecasts',
            isUseFilter: true,
            apiFilter: `
          // 可以使用data访问api请求的响应结果
let seriesList = []

let seriesListKey = 'city'
let seriesListChildrenKey = 'casts'

data.forEach((item) => {
  seriesList.push(item[seriesListKey])
})
dataSet.seriesList = seriesList
dataSet.source = []
data.forEach((item) => {
  item[seriesListChildrenKey].forEach(item2 => {
    dataSet.source.push({
      s: item[seriesListKey],
      x: item2.date,
      y: item2.daytemp
    })
  })
})
          `,
            apiUrlMethod: 'get',
            isUseInterval: true,
            apiInterval: 10,
            apiUrlMethod: 'get',
            apiPostParams: '',
            isUseUserKey: true, // 是否使用user_key
          },
          staticData: {
            seriesList: ['人数'],
            source: [],
          },
        },
      },
      posSize: {
        lable: '位置尺寸',
        propertyComponentName: 'ChartsPosSizeConfiger',
        value: {
          width: 300,
          height: 80,
          left: 0,
          top: 0,
        },
      },
      fontStyle: {
        lable: '图表文字样式',
        propertyComponentName: 'ChartsFontStyleConfiger',
        value: {
          titleSize: 16,
          titleColor: '#ccc',
          xAxisSize: 14,
          xAxisColor: '#fff',
          yAxisSize: 14,
          yAxisColor: '#fff',
        },
      },
      chartsGrid: {
        lable: '图表定位',
        propertyComponentName: 'ChartsGridConfiger',
        value: {
          left: '5%',
          right: '10%',
          bottom: '0%',
          top: '0%',
        },
      },
      showStatus: {
        value: 'norm',
      },
      chartsOpicity: {
        propertyComponentName: 'ChartsOpicityConfiger',
        value: 1,
      },
      gisMapConfig: {
        value: '',
        lable: '地图配置',
        propertyComponentName: 'SingleInputor',
      },
      mapBasicSetting: {
        value: {
          coordinate: {
            lng: '114.99982',
            lat: '25.85533',
          },
          zoom: 15,
          is3dMap: false,
        },
        propertyComponentName: 'mapBasicSetting',
        lable: '地图基本设置',
      },
      MapKey: {
        propertyComponentName: 'MapKeyConfiger',
        value: 'WKvseQPCaNwRbBDnLJtnm',
      },
      textComponentUnits: {
        propertyComponentName: 'MapTextConfiger',
        value: '元',
      },
      chartsAnimation: {
        propertyComponentName: 'ChartsAnimationConfiger',
        value: {
          isUseAnimation: false,
          isUseStaticRefresh: false,
          staticRefreshIntervalTime: 5,
        },
      },
    },
  },
};
</script>

<style scoped lang="scss">
.GisMapBackground {
  height: 100%;
  position: absolute;
  width: 96%;
  height: 92%;
  z-index: 0;
}
.Others29Charts {
  width: 100%;
  height: 100%;
  display: flex;
  gap: 2%;
  .left-panel {
    width: 24%;
  }

  .panel-title {
    background: url('../../../assets/img/toilet/title.png') no-repeat;
    background-size: 100% 100%;
    text-align: center;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .panel-content {
    height: 94%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #0a2148;
  }
  .toilet-stats {
    height: 26%;
    width: 90%;
  }
  .gender-toilet {
    height: 70%;
    width: 90%;
  }

  .toilet-stats .top {
    display: flex;
    align-items: center;
    height: 100%;
    justify-content: space-around;
  }

  .toilet-stats .top .icon {
    width: 30%;
    height: 60%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .toilet-stats .top .icon img {
    width: 80%;
  }

  .toilet-stats .top .text {
    color: #fff;
  }

  .toilet-stats .top .text span {
    margin: 2px 0;
  }
  .toilet-stats .top .totlo {
    display: flex;
    justify-content: space-between;
  }
  .toilet-stats .top .totlo span:nth-of-type(2) {
    color: #05acf5;
  }
  .toilet-stats .top .status {
    display: flex;
    gap: 10px;
    margin-top: 5px;
  }

  .toilet-stats .top .status .used {
    background-color: #f5a623;
    padding: 4px 8px;
    border-radius: 4px;
  }

  .toilet-stats .top .status .free {
    background-color: #2698e8;
    padding: 4px 8px;
    border-radius: 4px;
  }

  .gender-toilet {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .gender-toilet .item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    color: #ffff;
    height: 100%;
    background-color: #06518d;
  }
  .gender-toilet .item-content {
    width: 50%;
  }
  .gender-toilet .item-text {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
  .gender-toilet .item-num {
    display: flex;
    align-items: center;
    width: 74%;
    justify-content: flex-end;
  }
  .gender-toilet .item-num span:nth-of-type(1) {
    position: relative;
    right: 16%;
  }

  .gender-toilet .item .gender-icon {
    width: 26%;
    height: 68%;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
  }
  .gender-icon img {
    width: 80%;
  }
  /* 中间地图区域样式 */
  .middle-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  .map-title {
    background-color: #053d70;
    width: 30%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .map-container {
    height: 94%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0a2148;
  }

  /* 右侧环境数据区域样式 */
  .right-panel {
    width: 24%;
  }

  .env-data {
    height: 70%;
    width: 90%;
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .env-data .item {
    display: flex;
    justify-content: space-around;
    align-items: center;
    height: 20.22%;
    background-color: #06518d;
    color: #fff;
  }
  .env-data .item div:nth-of-type(2) {
    width: 40%;
    text-align: center;
  }
  .env-data .item .info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }
  .env-data .item .icon {
    width: 38%;
    gap: 16%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  /* .env-data .item .icon img {
    width: 80%;
  } */
}
</style>
